import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useVerwaltet } from "../lib/useVerwaltet";
import { SeitenSkelett } from "../components/SeitenSkelett";
import { RequireAuth } from "./Shell";

/**
 * Admin-Panel für globale Admins UND die Projektverwaltung einer Kommune
 * (Issues #125/#129). Was die Projektverwaltung darin sieht, entscheidet das
 * Panel selbst; die Endpunkte prüfen ohnehin je Projekt.
 */
export function RequireVerwaltung({ children }: { children: ReactNode }) {
  return (
    <RequireAuth>
      <Tor>{children}</Tor>
    </RequireAuth>
  );
}

function Tor({ children }: { children: ReactNode }) {
  const { darf, bereit } = useVerwaltet();
  if (!bereit) return <SeitenSkelett />;
  if (!darf) return <Navigate to="/" replace />;
  return <>{children}</>;
}
